var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",staticClass:"dropzone",attrs:{"action":_vm.url,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }